import { colors } from '@material-ui/core';
import { common } from '@material-ui/core/colors';
import * as images from 'images';

import { brandColors, contextColors, semanticColors } from './colors';
import shadows from './shadows';
import typography from './typography';
import zIndex from './zIndex';

const borderRadius = 10;

export default {
  direction: 'ltr',
  typography,
  palette: {
    type: 'light',
    primary: { main: colors.blue[500], contrastText: common.white },
    secondary: { main: brandColors.grey[700], contrastText: common.white },
    info: semanticColors.info,
    warning: semanticColors.warning,
    success: semanticColors.success,
    error: semanticColors.error,
    brand: brandColors,
    grey: {
      ...brandColors.grey,
      50: brandColors.grey[100],
      A100: brandColors.grey[300],
      A200: brandColors.grey[500],
      A400: brandColors.grey[600],
      A700: brandColors.grey[700],
    },
    context: {
      institutions: contextColors.institutions,
      sellers: contextColors.sellers,
    },
    background: {
      default: colors.common.white,
      dark: '#fafafa',
      paper: colors.common.white,
    },
    text: {
      primary: brandColors.grey[900],
      secondary: brandColors.grey[700],
    },
    action: {
      active: brandColors.grey[700],
      disabled: brandColors.grey[500],
    },
    divider: brandColors.grey[300],
  },
  shape: { borderRadius },
  shadows,
  themeName: 'Eskolare Default Theme 2019',
  zIndex,
  assets: {
    logoHorizontal: images.logoHorizontalColor,
    icon: images.logoSymbolSvg,
  },
  props: {
    MuiButton: { disableElevation: true },
    MuiContainer: { maxWidth: false },
  },
  overrides: {
    MuiAccordion: {
      rounded: {
        borderRadius,
        '&:before': { display: 'none' },
      },
    },
    MuiLinearProgress: {
      root: {
        borderRadius: 3,
        overflow: 'hidden',
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 32,
      },
    },
    MuiChip: {
      root: {
        backgroundColor: brandColors.grey[300],
        color: brandColors.grey[900],
      },
      icon: { marginLeft: 10, marginRight: -4 },
      iconSmall: { marginLeft: 8, marginRight: -2 },
      outlined: { '& $icon': { marginLeft: 10 }, '& $iconSmall': { marginLeft: 8 } },
    },
    MuiTableCell: {
      root: {
        borderBottom: `1px solid ${brandColors.grey[300]}`,
      },
      head: {
        backgroundColor: brandColors.grey[200],
        color: brandColors.grey[700],
        fontWeight: 700,
      },
      footer: {
        backgroundColor: brandColors.grey[200],
      },
      stickyHeader: {
        backgroundColor: brandColors.grey[200],
      },
    },
    MuiTablePagination: {
      root: {
        backgroundColor: brandColors.grey[200],
      },
    },
    MuiTableRow: {
      root: {
        '&$hover:hover': {
          backgroundColor: brandColors.grey[100],
        },
      },
    },
    MuiIconButton: {
      root: {
        '&:hover': {
          backgroundColor: brandColors.grey[200],
        },
      },
    },
    MuiListItem: {
      root: {
        '&$focusVisible': {
          backgroundColor: brandColors.grey[200],
        },
        '&$selected, &$selected:hover': {
          backgroundColor: brandColors.grey[200],
        },
      },
      button: {
        '&:hover': {
          backgroundColor: brandColors.grey[100],
        },
      },
    },
    MuiAutocomplete: {
      option: {
        '&[aria-selected="true"]': {
          backgroundColor: brandColors.grey[200],
        },
        '&[data-focus="true"]': {
          backgroundColor: brandColors.grey[100],
        },
        '&:active': {
          backgroundColor: brandColors.grey[200],
        },
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: brandColors.grey[100],
        },
      },
    },
    MuiNativeSelect: {
      select: {
        '&:focus': {
          backgroundColor: brandColors.grey[100],
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: common.white,
        '&:hover $notchedOutline': {
          borderColor: brandColors.grey[700],
        },
      },
      notchedOutline: {
        borderColor: brandColors.grey[400],
      },
    },
    MuiButton: {
      outlined: {
        backgroundColor: common.white,
        borderColor: brandColors.grey[400],
        '&:hover': {
          backgroundColor: brandColors.grey[100],
        },
      },
      contained: {
        color: brandColors.grey[900],
        '&:hover': {
          backgroundColor: brandColors.grey[100],
        },
      },
    },
  },
};
